import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";

export type FilterAprovationsType = {
  cliente?: string[];
  conjunto?: string[];
  local?: string[];
  unidade?: string[];
  aprovados?: boolean;
  reprovados?: boolean;
};

export type FilterAprovationsV2Type = {
  inicio: {
    de: number;
    ate: number;
  };
  form?: string[];
  usuario?: string[];
  cliente?: string[];
  conjunto?: string[];
  local?: string[];
  unidade?: string[];
  aprovados?: boolean;
  reprovados?: boolean;
};
class Aprovations {


  getAll = async (
    body: AuthBodyType,
    pendente: boolean,
    pageNumber: number,
    itensPerPage: number,
    from: number | null,
    to: number | null,
    filters: FilterAprovationsType
  ) => {
    try {
      const data: AxiosResponse = await api.post("/aprovacao/getAprovationByUser", {
        ...body,
        pendente,
        pageNumber,
        itensPerPage,
        from,
        to,
        filters,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  avaliar = async (body: AuthBodyType, comentario: string, status: string, usuarioExecutor: string, checklist: number, assinado: boolean, arquivo: string | null) => {
    try {
      const data: AxiosResponse = await api.post("/aprovacao/avaliar", {
        ...body,
        comentario,
        status,
        usuarioExecutor,
        checklist,
        assinado,
        arquivo
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  updateListAprovers = async (
    body: AuthBodyType,
    conjuntoId: string,
    listaAprovadores: {
      [usuarioId: string]: string[];
    },
    prioridadeAprovacao: {
      [name: string]: {
        [form: string]: number;
      };
    }
  ) => {
    try {
      const data: AxiosResponse = await api.post("/aprovacao/salvarAprovadores", {
        ...body,
        conjuntoId,
        listaAprovadores,
        prioridadeAprovacao,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  getAprovationByUserV2 = async (body: AuthBodyType, filters: FilterAprovationsV2Type, lastIndex: number | null, itensPerPage: number) => {
    try {
      const data: AxiosResponse = await api.post("/aprovacao/getAprovationByUserV2", {
        ...body,
        filters,
        lastIndex,
        itensPerPage,
      });
      if (data.status === 204) {
        return { execucoes: [], lastIndex: null, total: 0 };
      }
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };
}

export default Aprovations;
